"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function FolderOpenTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'folder-open',
        theme: 'twotone',
        nameWithTheme: 'folder-open-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: { fill: secondaryColor, d: 'M159 768h612.3l103.4-256H262.3z' },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2c-1.5-1.4-3.5-2.2-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'folder-open-twotone';
var FolderOpenTwoTone = temp;
exports.default = FolderOpenTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/twotone/FolderOpenTwoTone.js
// module id = 1214
// module chunks = 0